// define white list styles to avoid quill stripping
export const whiteListStyles = [
  'margin',
  'lineHeight',
  'color',
  'textDecoration',
  'cursor',
  'padding',
];
